import SaasConnectSettings from "../../../SaaSApps/shared/SaasConnectSettings";
import { SettingProps } from "../../interface";

export default function GithubSettings({ onBack }: SettingProps) {
    return <SaasConnectSettings provider="github" onBack={onBack} />;
}
